export enum AuthApiUrl {
  LOGIN  = '/api/auth/login',
  LOGOUT = '/api/auth/logout',
  STATUS = '/api/auth/status',

  ISSUE_REGISTER_CODE = '/api/auth/issue/register_code',
  ISSUE_RESET_CODE    = '/api/auth/issue/reset_code',
  VERIFY_CODE         = '/api/auth/verify/code',
  REGISTER            = '/api/auth/register',
  RESET_PASSWORD      = '/api/auth/reset/password',

  GET_REDIRECT = '/api/get/redirect',

  OAUTH_REGISTER = '/api/auth/oauth/register',
}

export enum UserApiUrl {
  CREATE = '/api/users/create',
  GET_MINE = '/api/users/mine',
}

export enum DiagnosisApiUrl {
  INDEX  = '/api/authentication/diagnoses',
  CREATE = '/api/authentication/diagnoses/create',
  DELETE = '/api/authentication/diagnoses/delete',
  RESULT = '/api/authentication/diagnoses/:diagnosisId/result',
}

export enum QuestionApiUrl {
  GET_CURRENT = '/api/diagnoses/:diagnosisId/question',
}

export enum AnswerApiUrl {
  CREATE = '/api/diagnoses/:diagnosisId/answers/create',
  UPDATE = '/api/diagnoses/:diagnosisId/answers/update',
  DELETE = '/api/diagnoses/:diagnosisId/answers/delete',
}

export enum ResultApiUrl {
  GET    = '/api/diagnoses/:diagnosisId/result',
  CREATE = '/api/diagnoses/:diagnosisId/result',
}

export enum AnsweredApiUrl {
  GET = '/api/diagnoses/:diagnosisId/answered',
}